export default __webpack_public_path__ + "static/media/spark_22.f6cbecc5.png";